import type { TFunction } from "i18next";
import U2000SaveCancelDialog from "../../../../../u2000Core/components/dialog/U2000SaveCancelDialog";
import type { U3148AffilaitionRoleHandler } from "./U3148AffilaitionRoleHandlers";
import type { U3148Role } from "../../../../U3148Service";

// Typage des props du composant
interface U3148AffilaitionRoleDlgProps {
  u3148AffilaitionRoleHandler: U3148AffilaitionRoleHandler;
  t: TFunction;
  NS: string;
}

// Composant pour le dialogue d'édition des actions d'une unité logique
function U3148AffilaitionRoleEditDlg({ u3148AffilaitionRoleHandler, t, NS }: U3148AffilaitionRoleDlgProps) {
  // Unified handler that manages Save and Cancel differently
  const handleClose = (action: "save" | "cancel") => {
    // For this component, we don't have formStateHandlers, so just pass through the action
    u3148AffilaitionRoleHandler.onDlgClose(action);
  };

  // renmder
  return (
    <U2000SaveCancelDialog width="w-[700px]" isOpen={u3148AffilaitionRoleHandler.isDialogOpen} onClose={handleClose} title={t("user.lblRole", { ns: NS })}>
      <div className="flex flex-col gap-y-4">
        {u3148AffilaitionRoleHandler.roles &&
          u3148AffilaitionRoleHandler.roles.map((role: U3148Role, index) => (
            <div key={index} className="mb-1 flex items-center gap-x-2">
              <div
                className={`h-6 w-6 cursor-pointer rounded-sm border-2 transition-colors duration-300 ${role.idChecked ? "border-blue-500 bg-blue-100" : "border-gray-300 bg-white"}`}
                onClick={() => u3148AffilaitionRoleHandler.onCheckRole(role)}
              >
                {role.idChecked && (
                  <svg className="m-auto h-5 w-5 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <p className="inline-block text-gray-800">
                {role.roleCode} - {role.roleDescription}
              </p>
            </div>
          ))}
      </div>
    </U2000SaveCancelDialog>
  );
}

export default U3148AffilaitionRoleEditDlg;
